import { computed } from 'vue';

export function useAnswerExtraction(getAnswer) {
    const extractedParts = computed(() => {
        const initialAnswer = getAnswer();

        return extractAnswerAndReasoning(initialAnswer);
    });

    return extractedParts;
}

export function extractAnswerAndReasoning(initialAnswer, noneValues = ['none']) {
    if (!initialAnswer) {
        return {
            answer: '',
            reasoning: '',
            hasNoneAnswer: true,
            answerStart: -1,
            answerEnd: -1,
            reasoningStart: -1,
            reasoningEnd: -1,
        };
    }

    const reasoningPattern = /<\s*res\s*>([\s\S]*?)(<\s*\/\s*res\s*>|<\s*\\\s*res\s*>|$)/i;
    const answerPattern = /<\s*ans\s*>([\s\S]*?)(<\s*\/\s*ans\s*>|<\s*\\\s*ans\s*>|$)/i;

    let reasoningMatch = reasoningPattern.exec(initialAnswer);
    let answerMatch = answerPattern.exec(initialAnswer);

    let reasoning = '';
    let answer = '';

    let reasoningStart = -1;
    let reasoningEnd = -1;
    let answerStart = -1;
    let answerEnd = -1;

    if (reasoningMatch) {
        reasoning = reasoningMatch[1];
        reasoningStart = reasoningMatch.index + reasoningMatch[0].indexOf(reasoningMatch[1]);
        reasoningEnd = reasoningStart + reasoning.length;
    }

    if (answerMatch) {
        answer = answerMatch[1];
        answerStart = answerMatch.index + answerMatch[0].indexOf(answerMatch[1]);
        answerEnd = answerStart + answer.length;
    } else if (!reasoningMatch) {
        // If there's no reasoning or answer tags, treat the entire input as the answer
        answer = initialAnswer;
        answerStart = 0;
        answerEnd = initialAnswer.length;
    }

    const hasNoneAnswer =
        !answer ||
        noneValues.some((noneValue) => new RegExp(`^${noneValue}$`, 'i').test(answer.trim()));

    if (hasNoneAnswer) {
        answer = '';
    }

    return {
        answer,
        reasoning,
        hasNoneAnswer,
        answerStart,
        answerEnd,
        reasoningStart,
        reasoningEnd,
    };
}
